import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { translate } from 'react-i18next';

import CollectionContext from 'contexts/Collections';

import Modal from 'components/Modal';
import AddToCollection from './AddToCollection';
import {
	GhostButton,
} from 'lib/styles';

import Item from './Item';
import { Container } from './styles';

class BuildingList extends React.Component {
	state = {
	  viewBrochures: false,
	  buildingSlug: false,
	}

	render() {
	  const { props } = this;
	  const { t } = props;
	  return (
	    <CollectionContext.Consumer>
	      {({ collection, collections, collectionHandler }) => {
	        const collectionData = collections.find(c => c.id === collection);

	        return (
	          <React.Fragment>
	            <Container view={props.browseType}>
	              {props.buildings.map((building, index) => {
	                const { slug } = building;
	                const brochuresInCollection = collectionData && collectionData.brochures.some(brochure => building.brochures.includes(brochure));

	                return (
	                  <Item
	                    language={i18n.language}
	                    activeFilters={this.props.activeFilters}
	                    onlyFree={this.props.onlyFree}
	                    key={slug}
	                    building={building}
	                    collectionData={collectionData}
	                    brochuresInCollection={brochuresInCollection}
	                    browsetype={props.browseType}
	                    collectionHandler={collectionHandler}
	                    viewBrochuresHandler={() => {
	                      this.setState({
	                        viewBrochures: true,
	                        buildingSlug: building.slug,
	                      })
	                    }}
	                  />
	                )
	              })}
	            </Container>
	            {
	              this.state.viewBrochures &&
								<Modal
								  header={t('browse/Add brochures to collection')}
								  body={(
								    <AddToCollection
								      baseUrl={this.props.baseUrl}
								      building={this.state.buildingSlug}
								      brochures={props.buildings.find(b => b.slug === this.state.buildingSlug).brochures}
								      collectionData={collectionData}
								      collectionHandler={collectionHandler}
								    />
								  )}
								  footer={
								    <React.Fragment>
								      <GhostButton
								        onClick={() => this.setState({ viewBrochures: false })}
								      >
								        {t('building/images/modal/close')}
								      </GhostButton>
								    </React.Fragment>
								  }
								/>
	            }
	          </React.Fragment>
	        )
	      }}
	    </CollectionContext.Consumer>
	  )
	}
}

BuildingList.defaultProps = {
	buildings: [],
	browseType: 'tile',
};

BuildingList.propTypes = {
	activeFilters: PropTypes.array,
	onlyFree: PropTypes.bool,
	baseUrl: PropTypes.string,
	buildings: PropTypes.array.isRequired,
	browseType: PropTypes.string,
	unfilteredLength: PropTypes.number,
};

export default translate('translations')(BuildingList)
